/* src/app/components/case-manager/case-manager-list/case-manager-list.component.css */
.table-style {
  width: 100%;
}
/*# sourceMappingURL=case-manager-list.component-U7YN6PID.css.map */
